import { render, staticRenderFns } from "./BrandListing.vue?vue&type=template&id=31911e29&scoped=true&"
import script from "./BrandListing.vue?vue&type=script&lang=js&"
export * from "./BrandListing.vue?vue&type=script&lang=js&"
import style0 from "./BrandListing.vue?vue&type=style&index=0&id=31911e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31911e29",
  null
  
)

export default component.exports